<template>
    <button @click="handleIncrement">Increment: {{ count }}</button>
</template>

<script>
    export default {
        name: "Counter",
        props: ['initial'],

        data () {
            return {
                count: this.initial
            }
        },

        methods: {
            handleIncrement () {
                this.count++;
                this.$emit('increment');
            }
        }
    }
</script>

<style scoped>
    button {
        padding: 5px 20px;
        margin: 0 10px 0 0;
    }
</style>